import poortrait from '../assets/portrait-n.png';


function About(){
    return (
        <div className="about">
            <div className="about-container">
                {/* <div className="about-bg1"> */}
                    {/* <div className="about-bg2"> */}
                        <div className='info-container'>
                            <img src={poortrait} className='portrait' alt='portrait'/>
                            <div className='info-container-tex'>
                                <div className='title'>
                                    <p>Natsumi H.</p>
                                    <p>Motion Designer / Creative Developer</p>
                                </div>
                                <div className='links'>
                                    <a href="https://www.instagram.com/natsumih__d?igsh=MWI2NGtqeHhtejQwYQ%3D%3D&utm_source=qr" style={{textDecoration:"underline 1px"}} target="_blank" rel="noopener noreferrer">Instagram</a>
                                    <br/>
                                    <a href="https://www.linkedin.com/in/natsumi-hashimoto-060752321" style={{textDecoration:"underline 1px"}} target="_blank" rel="noopener noreferrer">LinkedIn</a>
                                </div>
                            </div>
                        </div>
                        <div className='myself'>
                            <p>Multidisciplinary designer and developer with experience in CGI content creation, app development, and immersive installations. I bring a refined aesthetic sense, honed through hands-on work across 3D and 2D design, motion graphics, and interactive technologies</p>
                            <p className="jptext">CGIコンテンツ制作、アプリ開発、インスタレーション制作などの経験をバックグラウンドに持つクリエイティブデザイナー。3DCGやコーディングを用いたビジュアル制作やR＆Dを得意とし、媒体にとらわれない柔軟な制作アプローチと包括的なアートディレクションが可能です。</p>
                        </div>
                        <div className='email'>
                            <a href="mailto:natsumih.design@gmail.com" style={{textDecoration:"underline 1px"}}>natsumih.design@gmail.com</a>
                        </div>
                        <br/><br/>
                        <div className='skills'>
                            <h3>Skills</h3>
                            <div>
                                <p>3D design</p>
                                <p>Motion design</p>
                                <p>Art direction</p>
                                <p>App development</p>
                            </div>
                            <p>-</p>
                            <div>
                                <p>Houdini / Blender / Cinema4D</p>
                                <p>After Effects / Illustrator / Photoshop / Figma</p>
                                <p>Unity / Unreal Engine / Touch Designer</p>
                                <p>HTML / CSS / JavaScript / C# / Python</p>
                                <p>Three.js / React</p>
                            </div>
                            <p>-</p>
                            <div>
                                <p>Languages: Japanese, English</p>
                            </div>
                            <br/>
                            <div className='works-archive'>
                                <h3>Works Archive</h3>
                                <div>
                                    <p>Showreel 2026 : <a href="https://youtu.be/X4idLiunJuE" style={{textDecoration:"underline 1px"}} target="_blank" rel="noopener noreferrer">You Tube</a></p>
                                    <p>For more works, please visit my <a href="https://ebony-success-4de.notion.site/Works-Gallery-3c8f7165f73b80f39bbbfe314d74a185?source=copy_link" style={{textDecoration:"underline 1px"}} target="_blank" rel="noopener noreferrer">Notion</a> page.</p>
                                </div>
                            </div>
                        </div>
                    {/* </div> */}
                {/* </div> */}
            </div>
        </div>
    );
}
export default About;